// removed by extract-text-webpack-plugin
module.exports = {"coverImage":"_1Ahbk_qPD1R_gImDQpSxnx","content":"Fke4Do4EkzNEJEngZQcK7","image":"_3YTQdcsVv6rlZHShzVCPTn","shadow300":"_2mldl8xiif36dEGCxFvbOo","shadow500":"_2SuxBKnkG-TuhOkg-q55qH"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/ImageContent/style.css
// module id = 271
// module chunks = 37